import { aws_exports } from '@akin-home/amplify';
import DeviceInfo from 'react-native-device-info';

const getAppEnv = () => {
  // Returns what environment the app is running with e.g, dev, prod, etc.
  const env = aws_exports.aws_user_files_s3_bucket.split('-', 2)[1];
  return env ?? 'unknown';
};

/** Only works for android and ios */
export const getAppVersion = () => `${DeviceInfo.getVersion()}+${getAppEnv()}`;
